'use client'
import React, { useState } from 'react'
import classNames from 'classnames'
import Icon, { IconName } from '../icon'
import { ColorTheme } from '@dustin-web/styledust/constants'
import Button from '../button'
import List from '../list'
import { Banner, SharedProps, BannerProps } from './banner'

export enum NotificationTypes {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
}

type NotificationType = `${NotificationTypes}`

type CaseProps =
  | { ctaButton: boolean | true; primaryButton?: boolean; href: string; buttonText: string }
  | { ctaButton?: false; primaryButton?: never; href?: never; buttonText?: never }

type Props = {
  type: NotificationType | string
  customIcon?: IconName
  hideIcon?: boolean
  title?: string
  description?: string
  list?: string[]
  children?: React.ReactNode
} & SharedProps &
  CaseProps

export const NotificationBanner = (props: Props) => {
  const [close, onClose] = useState(false)

  if (close) {
    return
  }

  const {
    children,
    primaryButton,
    closeable,
    hideIcon,
    customIcon,
    title,
    description,
    list,
    ctaButton,
    href,
    buttonText,
    type,
  } = props
  const listItems = list?.length && list.length > 0 ? list?.map(item => ({ title: item })) : false
  let icon = customIcon
  let color: ColorTheme = 'light-blue'

  switch (type) {
    case NotificationTypes.ERROR:
      icon = icon ?? 'warning'
      color = 'light-red'
      break
    case NotificationTypes.WARNING:
      icon = icon ?? 'info-attention'
      color = 'light-yellow'
      break
    case NotificationTypes.INFO:
      icon = icon ?? 'info'
      color = 'light-blue'
      break
    case NotificationTypes.SUCCESS:
      icon = icon ?? 'check'
      color = 'light-green'
      break
  }
  const bannerProps: BannerProps = {
    color: color,
    border: true,
    ...props,
    onClose,
  }

  return (
    <>
      <Banner {...bannerProps}>
        <div className={classNames('d-flex', closeable ? 'u-mr-32' : 'u-mr-0')}>
          {!hideIcon && icon && <Icon name={icon} className="i-20 u-mr-8" />}
          <div
            className={classNames(
              'text-button-container d-flex flex-column flex-md-row justify-content-md-between'
            )}>
            <div className="text-block u-mr-8">
              {title && (
                <p
                  className={classNames(
                    description || listItems || ctaButton ? 'u-mb-8' : 'u-mb-0',
                    'u-fs-14 u-fw-bold'
                  )}>
                  {title}
                </p>
              )}
              {description || children ? (
                <p className={classNames(listItems || ctaButton ? 'u-mb-8' : 'u-mb-0', 'u-fs-14')}>
                  {description}
                  {children}
                </p>
              ) : null}
              {listItems && (
                <List
                  className={classNames(ctaButton ? 'u-mb-8 u-mb-md-0' : 'u-mb-0', 'u-py-0')}
                  items={listItems}></List>
              )}
            </div>
            {ctaButton && (
              <Button
                link={true}
                href={href}
                text={buttonText}
                className={classNames('u-mb-0 u-mr-0 align-self-start align-self-md-center')}
                primary={primaryButton}
              />
            )}
          </div>
        </div>
      </Banner>
    </>
  )
}
